import { useNavigate } from "react-router-dom";

import { usePatientName } from "features/communications/hooks/usePatientName";
import { pathGenerators } from "utils/routes";

import styles from "./PatientNameLink.module.css";

const getFullName = (patient) =>
  `${patient?.firstName || ""} ${patient?.surname || ""}`.trim();

/*
 * The patient behind a row of any practice-wide communications list. Letters, sick
 * certs and SMS carry the whole patient on the row, so they pass it in; an email only
 * carries the id, so the name is fetched — hence the optional `patient`.
 */
export const PatientNameLink = ({ patientId, patient }) => {
  const navigate = useNavigate();
  const { data: fetchedPatient } = usePatientName(patient ? null : patientId);

  if (!patientId) return <span className={styles.emptyCell}>—</span>;

  const name = getFullName(patient ?? fetchedPatient) || `#${patientId}`;

  const handleClick = (event) => {
    event.stopPropagation();
    navigate(pathGenerators.patient.communication(patientId));
  };

  return (
    <button className={styles.patientLink} onClick={handleClick}>
      {name}
    </button>
  );
};
